export default __webpack_public_path__ + "static/media/tentKlein.4840c7e2.jpg";